// extracted by mini-css-extract-plugin
export default {"bullet-list":"style_bullet-list__4Yp3U","list-item":"style_list-item__CKxnC","arrow":"style_arrow__pPyDQ","check":"style_check__58Oqo"};